import CityPageTemplate from "../city-template/CityPageTemplate";
import { portlandMeConfig } from "./data";

export default function PortlandMePage() {
  return <CityPageTemplate config={portlandMeConfig} />;
}